import { FC, memo } from 'react'

import { Button, CheckIcon, Text } from '@cash-me/react-components'
import NextImage from "next/image"

import { Grid, Col } from 'components/grid'
import useWindowSize from 'hooks/useWindowSize'

import { EligibilityProps } from './eligibility.model'
import * as S from './styles'

const Eligibility: FC<EligibilityProps> = memo(({ onClick }) => {
  const { isTablet } = useWindowSize()

  return (
    <S.Section $bg="medium">
      <Grid col={{ phone: 1, tablet: 2 }}>
        <Col col={{ desktop: 5 }} start={{ desktop: 2 }}>
          <S.MobImg>
            <NextImage
              src={`${process.env.NEXT_PUBLIC_SITE_IMAGES_PREFIX}/images/site/defaulter/eligibility-mobile.png`}
              alt="Moça comemorando que pode conseguir um empréstimo com a CashMe"
              width="311"
              height="224"
              priority
              sizes="100vw"
              style={{
                width: "100%",
                height: "auto"
              }} />
          </S.MobImg>

          <S.DeskImg>
            <NextImage
              src={`${process.env.NEXT_PUBLIC_SITE_IMAGES_PREFIX}/images/site/defaulter/eligibility-desktop.png`}
              alt="Moça comemorando que pode conseguir um empréstimo com a CashMe"
              width="600"
              height="433"
              priority
              sizes="100vw"
              style={{
                width: "100%",
                height: "auto"
              }} />
          </S.DeskImg>
        </Col>
        <Col col={{ desktop: 5 }} start={{ desktop: 7 }}>
          <S.Infos>
            <Text className="subtitle" size="caption" weight="medium" uppercase>
              Elegibilidade
            </Text>
            <Text as="h2" size="heading3" weight="medium">
              <Text as="span" size="heading3" weight="medium" color="var(--colors-pink-text-default)">
                Quem pode contratar{' '}
              </Text>
              a Portabilidade de Dívidas?
            </Text>

            <Text color="var(--colors-neutral-text-weak)">
              Nossa Portabilidade de Dívidas é para qualquer pessoa. Na CashMe, temos o Empréstimo com Garantia de
              Imóvel, assim, fica muito mais fácil oferecer taxas atraentes e prazos estendidos. A única diferença é
              que, no momento da avaliação do crédito, o perfil é analisado e a proposta pode variar de acordo com a
              necessidade de cada cliente.
            </Text>

            <Text color="var(--colors-neutral-text-weak)">
              O melhor de tudo é que não importa o seu perfil: você decide como vai usar o dinheiro. Você pode organizar
              dívidas, reformar ou comprar um novo imóvel, abrir um negócio ou aplicar o valor onde mais você quiser.
            </Text>

            <Text color="var(--colors-neutral-text-weak)" weight="medium">
              Confira{' '}
              <Text as="span" color="var(--colors-pink-text-default)" weight="medium">
                quem pode solicitar
              </Text>{' '}
              a Portabilidade de Dívidas:
            </Text>

            <S.List>
              <S.ListItem>
                <CheckIcon color="var(--colors-cyan-icon-default)" />
                Pensionistas ou aposentados;
              </S.ListItem>
              <S.ListItem>
                <CheckIcon color="var(--colors-cyan-icon-default)" />
                Funcionários públicos;
              </S.ListItem>
              <S.ListItem>
                <CheckIcon color="var(--colors-cyan-icon-default)" />
                Pessoas físicas em geral;
              </S.ListItem>
              <S.ListItem>
                <CheckIcon color="var(--colors-cyan-icon-default)" />
                Empresas.
              </S.ListItem>
            </S.List>
          </S.Infos>

          <Button
            size="lg"
            {...(!isTablet ? { variants: 'text-only' } : { variants: 'default', iconName: 'arrowRight' })}
            onClick={onClick}
          >
            Simular agora
          </Button>
        </Col>
      </Grid>
    </S.Section>
  );
})

Eligibility.displayName = 'Eligibility'

export default Eligibility
